import { Modal, Paper } from '@mui/material';
import React from 'react';
import ReturnReasonTable from './ReturnReasonTable';

const ReturnReason = ({ open, onClose, selectedItems }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '70%',
          overflowY: 'auto',
          padding: '20px',
          backgroundColor: 'white',
          boxShadow: 24,
        }}
      >
        <ReturnReasonTable selectedItems={selectedItems} />
      </Paper>
    </Modal>
  );
};

export default ReturnReason;
